import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { SmartCampaignConstants } from '@/modules/ta/smartcampaign/smartcampaign.constants';
import { getters } from '@/modules/core/app/helpers/store';
import { CategoryService } from '@/modules/ta/category/models/CategoryService';

export class SmartCampaign extends BaseEntityModel {
  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  color;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  icon;

  /**
   * @var {string}
   */
  campaign_type;

  /**
   * @var {string}
   */
  campaign_type_display;

  /**
   * @var {string}
   */
  service_id;

  /**
   * @var {Array}
   */
  service_ids;

  /**
   * @var {string}
   */
  dataview;

  /**
   * @var {string}
   */
  dataview_display;

  /**
   * @var {boolean}
   */
  dynamic_mapping;

  /**
   * @var {string}
   */
  search_pattern;

  /**
   * @var {string}
   */
  mapping;

  /**
   * @var {string}
   */
  real_mapping;

  /**
   * @var {string}
   */
  primary_name;

  /**
   * @var {string}
   */
  customer_id;

  /**
   * @var {string}
   */
  customer_name;

  /**
   * @var {boolean}
   */
  can_data_source_be_edited;

  /**
   * @var {boolean}
   */
  can_data_view_be_edited;

  /**
   * @var {boolean}
   */
  data_source_edition_tooltip;

  /**
   * @var {boolean}
   */
  data_view_edition_tooltip;

  /**
   * @var {Array.<CategoryService>}
   */
  services;

  /**
   * @var {string}
   */
  external_id;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.color = model.color;
    this.name = model.name;
    this.icon = model.icon;
    this.campaign_type = getters.session.getUserSettings().isSmartCampaignFilteringEnabled
      ? SmartCampaignConstants.TYPE.FILTERING
      : SmartCampaignConstants.TYPE.GROUPING;
    this.campaign_type_display = `${this.campaign_type
      .charAt(0)
      .toUpperCase()}${this.campaign_type.slice(1)}`;
    this.service_id = model.service_id;
    this.service_ids = Object.keys(model.service_ids || {});
    this.services = Object.values(model.service_ids || {}).map(
      (service) => new CategoryService(service)
    );
    this.dataview = model.dataview;
    this.dataview_display = model.dataview_display;
    this.dynamic_mapping = model.dynamic_mapping;
    this.search_pattern = model.search_pattern;
    this.mapping = model.mapping || '[]';
    this.real_mapping = model.real_mapping || [];
    this.primary_name = model.primary_name;
    this.customer_id = model.customer_id;
    this.customer_name = model.customer_name;
    this.can_data_source_be_edited = model.can_data_source_be_edited;
    this.can_data_view_be_edited = model.can_data_view_be_edited;
    this.data_source_edition_tooltip = model.data_source_edition_tooltip;
    this.data_view_edition_tooltip = model.data_view_edition_tooltip;
    this.external_id = model.external_id || null;
  }

  /**
   * @returns {string}
   */
  getIcon() {
    return this.icon;
  }

  /**
   *
   * @returns {string}
   */
  getColor() {
    return this.color;
  }
}
